var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.9998V14.9998C2 15.8298 2.67 16.4998 3.5 16.4998C4.33 16.4998 5 15.8298 5 14.9998V10.9998C5 10.1698 4.33 9.49982 3.5 9.49982C2.67 9.49982 2 10.1698 2 10.9998ZM8 10.9998V14.9998C8 15.8298 8.67 16.4998 9.5 16.4998C10.33 16.4998 11 15.8298 11 14.9998V10.9998C11 10.1698 10.33 9.49982 9.5 9.49982C8.67 9.49982 8 10.1698 8 10.9998ZM1.5 21.4998H17.5C18.33 21.4998 19 20.8298 19 19.9998C19 19.1698 18.33 18.4998 17.5 18.4998H1.5C0.67 18.4998 0 19.1698 0 19.9998C0 20.8298 0.67 21.4998 1.5 21.4998ZM14 10.9998V14.9998C14 15.8298 14.67 16.4998 15.5 16.4998C16.33 16.4998 17 15.8298 17 14.9998V10.9998C17 10.1698 16.33 9.49982 15.5 9.49982C14.67 9.49982 14 10.1698 14 10.9998ZM8.57 0.989824L0.67 5.14982C0.26 5.35982 0 5.78982 0 6.24982C0 6.93982 0.56 7.49982 1.25 7.49982H17.76C18.44 7.49982 19 6.93982 19 6.24982C19 5.78982 18.74 5.35982 18.33 5.14982L10.43 0.989824C9.85 0.679824 9.15 0.679824 8.57 0.989824Z",
    fill: "#27BAC4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankIcon);
export default __webpack_public_path__ + "static/media/BankIcon.a5b263a69d0c1795446af6be153ba94c.svg";
export { ForwardRef as ReactComponent };